import EmptyState from "../store/emptyState";
import { UserContextActionConstants } from "../action-constants";
import globalReducerHelper from "./globalReducerHelper";
import { NotificationStatus } from "../../constants";
import { LocalStorageUtils } from "../../utils";

const {
  GET_SESSION_TIME_ERROR,
  GET_SESSION_TIME_FULFILLED,
  SET_ODDS_FORMAT,
  UPDATE_BALANCE,
  UPDATE_TICKETS,
  ALL_TICKETS_SEEN,
  UPDATE_DEVICE,
  UPDATE_MINI_CASHIER_DETAILS,
  UPDATE_IS_NATIVE,
  UPDATE_IS_NATIVE_IOS,
  UPDATE_IS_MOBILE_WEB_APP,
  UPDATE_IS_MOBILE_DEVICE
} = UserContextActionConstants;

const normalizeTickets = data =>
  data.reduce((acc, val) => {
    acc[val.id] = val.data;
    return acc;
  }, {});

const reduceTickets = (currentData, nextData) => {
  const normalizedTickets = normalizeTickets(nextData);

  // Initial handling
  if (!currentData || currentData.length === 0) {
    return normalizedTickets;
  }

  const result = currentData;
  nextData.forEach(document => {
    if (
      document.type === "removed" ||
      document.data.status !== NotificationStatus.Active
    ) {
      delete result[document.id];
    } else {
      // Upsert
      result[document.id] = {
        ...(result[document.id] || {}),
        ...document.data
      };
    }
  });

  return result;
};

const userContext = (state = EmptyState.userContext, action) => {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_BALANCE: {
      console.log(`In reducer, action BalanceUpdated, value: ${payload}`);
      return Object.assign({}, state, {
        userBalance: payload.AvailableOnBankrollCurrency,
        bonusBalance: payload.BonusBalance,
        realBR: payload.RealUserBalance
      });
    }
    case UPDATE_TICKETS: {
      console.log(`In reducer, action TicketsUpdated, value: ${payload}`);
      return {
        ...state,
        userTickets: {
          ...state.userTickets,
          tickets: reduceTickets(state.userTickets.tickets, payload)
        }
      };
    }

    case ALL_TICKETS_SEEN: {
      console.log(`In reducer, action AllTicketsSeen, value: ${payload}`);
      const { cid, userTickets } = state;
      const readTicketIds = Object.keys(userTickets.tickets);
      LocalStorageUtils.set(`readTicketIds-${cid}`, readTicketIds.join());

      return {
        ...state,
        userTickets: {
          ...userTickets,
          readTicketIds
        }
      };
    }

    case GET_SESSION_TIME_FULFILLED: {
      console.log(`In reducer, action UpdateSessionTime, value: ${payload}`);
      return Object.assign({}, state, {
        sessionTime: payload
      });
    }

    case GET_SESSION_TIME_ERROR: {
      return Object.assign({}, state, {
        error: payload
      });
    }

    case UPDATE_DEVICE: {
      console.log(`In reducer, action DeviceUpdated, value: ${payload}`);
      return Object.assign({}, state, {
        deviceType: payload
      });
    }

    case UPDATE_MINI_CASHIER_DETAILS: {
      return Object.assign({}, state, {
        miniCashierDetails: payload
      });
    }

    case SET_ODDS_FORMAT: {
      return Object.assign({}, state, {
        oddsFormat: payload
      });
    }

    case UPDATE_IS_NATIVE_IOS: {
      return Object.assign({}, state, {
        isNativeIOS: payload
      });
    }

    case UPDATE_IS_NATIVE: {
      return Object.assign({}, state, {
        isNative: payload
      });
    }

    case UPDATE_IS_MOBILE_WEB_APP: {
      return Object.assign({}, state, {
        isMobileWebApp: payload
      });
    }

    case UPDATE_IS_MOBILE_DEVICE: {
      return Object.assign({}, state, {
        isMobileDevice: payload
      });
    }

    default:
      return globalReducerHelper(
        state,
        type,
        payload && payload.userContext,
        EmptyState.userContext
      );
  }
};

export default userContext;
